import { v4 as uuid } from "uuid";
import findKey from "lodash/findKey";
import debugFactory from "debug";

const allTouched = touches => !findKey( touches, isTouched => !isTouched );
const anyTouched = touches => !!findKey( touches, isTouched => isTouched );
const allEmpty = errors => !findKey( errors, errorMessage => !!errorMessage );

const noop = () => {};

export const standardTouchForm = fields => {
	// eslint-disable-next-line no-unused-vars
	return ( form, untouchedForm, mergedOptions, mergedReadonlyData ) => {
		const { touchAll: coerce = false, } = mergedOptions;

		return fields.reduce( ( acc, field ) => {
			acc[ field ] =
				coerce || // force the field to be touched
				( form.touches && form.touches[ field ] ) || // field was previously touched
				form[ field ] !== untouchedForm[ field ]; // field is now touched
			return acc;
		}, {} );
	};
};

export default ( {
	// eslint-disable-next-line no-unused-vars
	emptyForm = ( i18n, mergedOptions = {}, mergedReadonlyData = {} ) => ( {} ),
	touchForm = standardTouchForm( [] ),
	// eslint-disable-next-line no-unused-vars
	validateForm = ( form, touches, i18n, mergedOptions = {}, mergedReadonlyData = {} ) => ( {} ),
	// eslint-disable-next-line no-unused-vars
	computeCapabilities = ( form, mergedOptions = {}, mergedReadonlyData = {} ) => ( {} ),
	defaultOptions = {},
	defaultReadonlyData = {},
	debugNamespace = "",
// eslint-disable-next-line max-params
} ) => {
	const debug = debugNamespace ?
		debugFactory( debugNamespace ) :
		noop;

	return ( {
		priorForm = {},
		options = {},
		readonlyData = {},
		i18n,
	} ) => {
		const mergedOptions = {
			...defaultOptions,
			...options,
		};

		const mergedReadonlyData = {
			...defaultReadonlyData,
			...readonlyData,
		};

		const formId = uuid();
		const untouchedForm = emptyForm( i18n, mergedOptions, mergedReadonlyData );

		const form = {
			formId,
			$untouchedForm: {
				...untouchedForm,
			},
			...untouchedForm,
			...priorForm,
			...mergedReadonlyData,
		};

		form.revision = ( form.revision || 0 ) + 1;
		form.touches = touchForm( form, form.$untouchedForm, mergedOptions, mergedReadonlyData );
		form.isTouched = anyTouched( form.touches );
		form.allFieldsTouched = allTouched( form.touches );
		form.errors = validateForm( form, form.touches, i18n, mergedOptions, mergedReadonlyData );
		form.allFieldsValid = allEmpty( form.errors );
		form.capabilities = computeCapabilities( form, mergedOptions, mergedReadonlyData );

		debug( form );

		return form;
	};
};
